namespace('IO.Views.PaymentDeviceTypes', function (exports) {
  'use strict';

  exports.Show = IO.Views.PaymentDeviceTypes.New;
});
